import { Modal } from "antd";
import { CaseStatusHistory } from "../ticket-history";

export const CaseStatusHistoryModal = ({
  caseStatusHistory,
  closeCaseHistoryModal,
}) => {
  return (
    <Modal
      destroyOnClose
      open={caseStatusHistory.isOpenModal}
      onCancel={closeCaseHistoryModal}
      footer={null}
      centered
      width="100dvw"
      styles={{
        content: {
          backgroundColor: "#F5F6F8",
          borderRadius: "20px",
          height: "97dvh",
        },
        header: { backgroundColor: "#F5F6F8" }, // turns the Modal red
      }}
    >
      <CaseStatusHistory case_id={caseStatusHistory?.id} />
    </Modal>
  );
};
